/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["button.clicker[_ngcontent-%COMP%]:disabled{color:#ccc;cursor:default!important;background-color:transparent}button.clicker[_ngcontent-%COMP%]:disabled   .location-group-rule-icon[_ngcontent-%COMP%]{opacity:.5}.list-group-item.border-warning[_ngcontent-%COMP%]{color:#000}.pointer-none[_ngcontent-%COMP%]{pointer-events:none}"];
export { styles as styles };
